// src/hooks/useRecentlyViewed.js

const KEY = "hh_recently_viewed";
const MAX_ITEMS = 10;

export const addToRecentlyViewed = (slug) => {
  if (!slug) return;
  const existing = getRecentlySlugs();
  const updated = [slug, ...existing.filter((s) => s !== slug)].slice(
    0,
    MAX_ITEMS,
  );
  localStorage.setItem(KEY, JSON.stringify(updated));
};

export const getRecentlySlugs = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || [];
  } catch {
    return [];
  }
};

export const clearRecentlyViewed = () => {
  localStorage.removeItem(KEY);
};
